const listCounterReset = (start: number): string | undefined => (start === 1 ? undefined : `listitem ${start - 1}`);

export default listCounterReset;
